import {
  BEST_OF_WOLT_NAVIGATION_ITEM,
  BUSINESS_DETAILS_NAVIGATION_ITEM,
  PURCHASES_NAVIGATION_ITEM,
  TRANSLATION_NAVIGATION_ITEM,
} from '../constants';
import { NavigationItem } from '../types';

export const useVenueNavigationItems = (): NavigationItem[] => {
  // TODO: Begin: Implement logic to determine if best of wolt navigation should be shown
  const shouldShowBestOfWoltNavigation = true;
  const shouldShowBusinessDetailsNavigation = true;
  const shouldShowPurchaseNavigation = true;
  const shouldShowTranslationNavigation = true;

  // TODO: End: Implement logic to determine if best of wolt navigation should be shown

  return [
    ...(shouldShowBestOfWoltNavigation ? [BEST_OF_WOLT_NAVIGATION_ITEM] : []),
    ...(shouldShowBusinessDetailsNavigation ? [BUSINESS_DETAILS_NAVIGATION_ITEM] : []),
    ...(shouldShowPurchaseNavigation ? [PURCHASES_NAVIGATION_ITEM] : []),
    ...(shouldShowTranslationNavigation ? [TRANSLATION_NAVIGATION_ITEM] : []),
  ];
};
